// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"d6b1cf08","419":"3ab02f68","563":"24e3c73f","942":"923a7190"}[chunkId] + ".chunk.js";
};